module.exports = __webpack_public_path__ + "static/media/22.a507bf6a.jpg";